import { getToken } from 'firebase/messaging'
import { setFcmTokenCookie } from '@/src/utils/authCookies'
import { getFirebaseMessaging } from './firebase'

export async function getFcmToken(): Promise<string | null> {
    const messaging = await getFirebaseMessaging()
    if (!messaging) return null

    if (Notification.permission === 'default') {
        const permission = await Notification.requestPermission()
        if (permission !== 'granted') return null
    } else if (Notification.permission !== 'granted') {
        return null
    }

    const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js')
    await navigator.serviceWorker.ready

    const token = await getToken(messaging, {
        vapidKey: process.env.NEXT_PUBLIC_FIREBASE_VAPID_KEY,
        serviceWorkerRegistration: registration,
    })

    if (token) {
        setFcmTokenCookie(token)
    }

    return token
}
